export const TRUE = 1;
export const FALSE = 0;